var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3V2.6C7 2.03995 7 1.75992 6.89101 1.54601C6.79513 1.35785 6.64215 1.20487 6.45399 1.10899C6.24008 1 5.96005 1 5.4 1H4.6C4.03995 1 3.75992 1 3.54601 1.10899C3.35785 1.20487 3.20487 1.35785 3.10899 1.54601C3 1.75992 3 2.03995 3 2.6V3M4 5.75V8.25M6 5.75V8.25M0.5 3H9.5M8.5 3V8.6C8.5 9.44008 8.5 9.86012 8.33651 10.181C8.1927 10.4632 7.96323 10.6927 7.68099 10.8365C7.36012 11 6.94008 11 6.1 11H3.9C3.05992 11 2.63988 11 2.31901 10.8365C2.03677 10.6927 1.8073 10.4632 1.66349 10.181C1.5 9.86012 1.5 9.44008 1.5 8.6V3",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.9433d64c9117f6f6d44c3b81f3f1fe19.svg";
export { ForwardRef as ReactComponent };